import { replyTypes } from '../../data'
import { lang } from '../../assets/lang'
import { getSelectOptionsFromArrayOfObjects } from '../../utils/functions'

export const quickReplyHtml =
'<div class="form-group text-left mt-2">' + 
  '<label for="quick-reply-type">' + lang.quick_reply_html_label_reply_type + '</label>' +
  '<select id="quick-reply-type" class="form-control select2">' +
    '<option value="">' + lang.quick_reply_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(replyTypes) +
  '</select>' +
'</div>' +

'<div id="quick-reply-button-text-group" class="form-group text-left mt-2 d-none">' + 
  '<label for="quick-reply-button-text">' + lang.quick_reply_html_label_button_text + '</label>' +
  '<input type="text" class="form-control" id="quick-reply-button-text" aria-describedby="quick-reply-button-text-help">' +
'</div>' +

'<div id="quick-reply-postback-group" class="form-group text-left mt-2 d-none">' + 
  '<label for="quick-reply-postback">' + lang.quick_reply_html_label_postback_id + '</label>' +
  '<select id="quick-reply-postback" class="form-control select2">' +
    '<option value="">' + lang.quick_reply_html_title_select + '</option>' +
  '</select>' +
'</div>'